export const language: any = {
    OkLogout: "Oui",
    CloseLogout: "Non",
    OkLeave: "Désinscription",
    CloseLeave: "Annuler",
    LabelPolicy: "Politique de confidentialité",
    AppName: "Hey! Cooker",
    OnOffNotification: "Notifications Activé/Désactivé",
    LabelReceiveNotificationSuggestion: "Recevoir des notifications de suggestions de recettes",
    LabelReceiveNotifyBreakfast: "Recevoir des recommandations quotidiennes pour le petit-déjeuner",
    LabelReceiveNotifyLunch: "Recevoir des recommandations quotidiennes pour le déjeuner",
    LabelReceiveNotifyDinner: "Recevoir des recommandations quotidiennes pour le dîner",
    notification_history: "Historique des notifications",
    readAll: "Tout lire",
    no_notification: "Aucun historique de notification",
    labelDisplayName: "Entrer le nom d'affichage",
    placeholderDisplayName: "Saisissez au moins 4 caractères, maximum 20 caractères",
    changeDisplayName: "Changer le nom d'affichage",
};